import type { ReactNode } from "react";

interface HeaderProps {
  nav?: ReactNode;
  right?: ReactNode;
}

export function Header({ nav, right }: HeaderProps) {
  return (
    <header>
      <div className="brand">
        <img
          src="/originstamp-logo.jpeg"
          alt="Originstamp"
          className="brand-logo"
        />
        <h1>Velocity</h1>
      </div>
      {nav && <nav className="header-nav">{nav}</nav>}
      {right ? <div id="user-bar">{right}</div> : <div id="user-bar" />}
    </header>
  );
}
